import React from 'react';

import useStyles from 'isomorphic-style-loader/useStyles';

import s from './CourseProgressBar.scss';
import { ICourseProgress } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';

interface ICourseProgressBarProps {
	progress: ICourseProgress;
}
export function CourseProgressBar({
	progress,
}: ICourseProgressBarProps): JSX.Element {
	useStyles(s);
	const progressPercent = progress.lastCompletedMaterialIndex === -1
		? 1
		: ((progress.lastCompletedMaterialIndex + 1)
                  / progress.allRequiredMaterialsLength)
              * 100;

	return (
		<div className="le-course-progress-bar">
			<div
				className="le-course-progress-bar__passed"
				style={{ width: `${progressPercent}%` }}
			/>
		</div>
	);
}
